import {shopModule} from '../module.js';
import '../services/postalCodeService.js';

shopModule.directive('nsPostalCode', ['$http','nsPostalCodeService', function($http, nsPostalCodeService) {
    return {
        require: 'ngModel',
        link: function(scope, ele, attr, ctrl) {
            // We need to store the last postal code because SEAShoppe has a form for each country and they all bind to
            // the same model as well as the preshippingform and the shippingform.  This way we don't make the ajax call
            // unless we have a new postalcode
            window.lastPostalCode = "";

            function addToArray(array, value, description) {
                let found = false;
                for (let i=0; i<array.length; i++) {
                    if (array[i].value == value) {
                        found =true;
                        break;
                    }
                }
                if (!found) {
                    array.push({value:value, description: description})
                }
            }

            function postalCodeLookup() {
                //Get the model from the ng-model attribute and strip off the shippingPostalCode
                let model = scope.$eval(attr.ngModel.substr(0,attr.ngModel.lastIndexOf(".")));
                model.cities=[];
                model.states=[];
                model.counties=[];
                //lookup postal code
                //must use shipping country in newAddress form for seaShoppe
                if (ele.val()) {
                    nsPostalCodeService.query({cntry: model.shippingCountry, code: encodeURIComponent(ele.val())}, function (data) {
                        //build ng-options for city state and county dropdowns
                        for (let i = 0; i < data.length; i++) {
                            //If there is a regionDescription use it as the description else use the value as the description
                            if (typeof(data[i].regionDesc) != "undefined" && data[i].regionDesc != null) {
                                if (typeof(data[i].region) != "undefined" && data[i].region != null) {
                                    addToArray(model.states, data[i].region, data[i].regionDesc);
                                }
                            } else {
                                if (typeof(data[i].region) != "undefined" && data[i].region != null) {
                                    addToArray(model.states, data[i].region, data[i].region);
                                }
                            }
                            if (typeof(data[i].districtDesc) != "undefined" && data[i].districtDesc != null) {
                                if (typeof(data[i].district) != "undefined" && data[i].district != null) {
                                    addToArray(model.counties, data[i].district, data[i].districtDesc);
                                }
                            } else {
                                if (typeof(data[i].district) != "undefined" && data[i].district != null) {
                                    addToArray(model.counties, data[i].district, data[i].district);
                                }
                            }
                            if (typeof(data[i].city) != "undefined" && data[i].city != null) {
                                addToArray(model.cities, data[i].city, data[i].city);
                            }
                        }

                        //Set default values to 1st element returned from postalcode lookup service
                        if (data.length > 0) {
                            if (typeof(data[0].region) != "undefined" && data[0].region != null) model.shippingState = data[0].region;
                            if (typeof(data[0].district) != "undefined" && data[0].district != null) model.shippingCounty = data[0].district;
                            if (typeof(data[0].city) != "undefined" && data[0].city != null) model.shippingCity = data[0].city;
                            if (typeof(data[0].street) != "undefined" && data[0].street != null) model.shippingAddress1 = data[0].street;
                            if (typeof(data[0].building) != "undefined" && data[0].building != null) model.shippingAddress1 += " " + data[0].building;
                            ctrl.$setValidity('nsPostalCode', true);
                        } else {
                            ctrl.$setValidity('nsPostalCode', false);
                        }
                    });
                }
            }

            // Watch the postal code for a change when the field doesn't have focus
            scope.$watch(attr.ngModel,function(newValue) {
                // Do postal code lookup if the postal code value changes when editing a form
                if (newValue && window.lastPostalCode != newValue) {
                    postalCodeLookup();
                    window.lastPostalCode = newValue;
                } else {
                    // Note that newValue==undefined means that the user enters something in the field
                    // but it does NOT pass other validation (e.g., pattern).
                    // However, ele.val() will indicate the user has entered something in the field.
                    if ((typeof(newValue) === "undefined") && ele.val()) {
                        window.lastPostalCode = ele.val();
                    } else {
                        // If newValue is undefined we still need to set lastPostalCode value
                        // If you cancel a form being edited then this will clear out the last value
                        window.lastPostalCode = newValue;
                    }
                }
            });
        }
    };
}]);
